<div class="content-block">
  <div class="row clearfix">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="card">
        <div class="body">
          <div class="row">
            <div class="col-md-12">
              <div class="white-box">
                <h3>
                  <b>Resultados</b>
                  <span class="float-end"></span>
                </h3>
                <hr />

                <form [formGroup]="form">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive m-t-40">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th class="text-center">Estudio</th>
                            <th class="text-center">Resultado</th>
                            <th class="text-center">Unidades</th>
                            <th class="text-center">Referencia</th>
                          </tr>
                        </thead>
                        @for (res of despRes; track res) {
                          <tbody>
                            <tr>
                              <td colspan="4" class="text-align">
                                <div class="flex tituloe">
                                  {{ res.NomEstudio }}
                                </div>
                              </td>
                            </tr>
                            @if (res['Componentes']) {
                              @for (comp of res['Componentes']; track comp) {
                                <tr>
                                  <td>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                                    comp['Componente']
                                    }}
                                  </td>
                                  <td class="text-center" [ngClass]="{'text-danger fw-bold': esAnormal(comp['Resultado'], comp['Referencia'])}">
                                    {{ formatResultado(comp['Resultado'], comp['Referencia']) }}
                                  </td>
                                  <td class="text-center">
                                    {{ comp['Unidades'] }}
                                  </td>
                                  <td class="text-center">
                                    {{ comp['Referencia'] }}
                                  </td>
                                </tr>
                                @if (tieneTabla(comp.Tabla) === true) {
                                  <tr>
                                    <td colspan="4" class="p-0 border-0">
                                      <div class="d-flex justify-content-end">
                                        <div style="max-height: 250px; width: 60%; overflow-y: auto; background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 4px; margin: 10px;">
                                          <pre class="m-0 p-3 text-muted" style="font-size: 0.9em; white-space: pre-wrap; word-break: break-all;">{{ comp['Tabla'] }}</pre>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                }
                              }
                            }
                            @if (res['Antibiograma'] && res['Antibiograma'].length > 0) {
                              <tr>
                                <td colspan="4" class="p-4">
                                  <div class="bg-light p-3 rounded border">
                                    <h6 class="text-primary mb-3"><i class="fas fa-microscope me-2"></i> Antibiograma</h6>
                                    <table class="table table-sm table-bordered bg-white mb-0">
                                      <thead class="table-light">
                                        <tr>
                                          <th>Antibiótico</th>
                                          <th class="text-center">Sensibilidad</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        @for (ab of res['Antibiograma']; track ab) {
                                          <tr>
                                            <td>{{ ab.IDAB }}</td>
                                            <td class="text-center" [ngClass]="{'text-danger fw-bold': ab.Resultado && ab.Resultado.toLowerCase().includes('resistente'), 'text-success': ab.Resultado && ab.Resultado.toLowerCase().includes('sensible')}">
                                              {{ ab.Resultado }}
                                            </td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            }
                          </tbody>
                        }
                      </table>
                    </div>
                  </div>
                  <div
                    class="intro-y col-span-12 overflow-auto lg:overflow-visible"
                    >
                    <table class="table table-report -mt-2 mat-row mat-cell">
                      @for (restx of despResTexto; track restx) {
                        <tbody
                          class="mat-row mat-cell"
                          >
                          <tr class="intro-x">
                            <td colspan="4" class="w-40">
                              <div class="flex tituloe">
                                {{ restx.NomEstudio }}
                              </div>
                            </td>
                          </tr>
                          <tr class="intro-x">
                            <td colspan="4" class="w-40">
                              <div class="flex tituloe">
                                <div>
                                  <ejs-richtexteditor
                                    id="fromTx"
                                    formControlName="reporte"
                                    [toolbarSettings]="tools"
                                    >
                                  </ejs-richtexteditor>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      }
                    </table>
                  </div>
                  <div class="mat-elevation-z2">
                    <div
                      class="intro-y col-span-12 overflow-auto lg:overflow-visible"
                      >
                      <table class="table table-report -mt-2 mat-row mat-cell">
                        @for (resrx of despResRX; track resrx; let i = $index) {
                          <tbody
                            class="mat-row mat-cell"
                            >
                            <tr class="intro-x">
                              <td colspan="4" class="w-40">
                                <div class="flex tituloe">
                                  {{ resrx.NomEstudio }}
                                </div>
                              </td>
                            </tr>
                            <tr class="intro-x">
                              <td colspan="4" class="w-40">
                                <div class="flex tituloe">
                                  <div>
                                    <ejs-richtexteditor
                                      id="fromRx"
                                      formControlName="resultado"
                                      >
                                    </ejs-richtexteditor>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        }
                      </table>
                    </div>
                  </div>
                  <!-- Loading spinner -->
                  @if (isTblLoading) {
                    <div class="tbl-spinner">
                      <mat-progress-spinner
                        color="primary"
                        [diameter]="50"
                        mode="indeterminate"
                        >
                      </mat-progress-spinner>
                    </div>
                  }
                  <div class="col-md-12">
                    <div class="clearfix"></div>
                    <hr />
                    <div class="text-end">
                      <button mat-raised-button color="primary">
                        <i class="fas fa-print msr-2"></i>Imprimir
                      </button>
                    </div>
                  </div>
                  

                </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
